import { Component, ViewEncapsulation } from "@angular/core";
import { MdbModalRef } from "mdb-angular-ui-kit/modal";

@Component({
  selector: "app-acknowledgments-modal",
  templateUrl: "./acknowledgments-modal.component.html",
  styleUrls: ["./acknowledgments-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AcknowledgmentsModalComponent {
  constructor(
    public modalRef: MdbModalRef<AcknowledgmentsModalComponent>,
  ) {}

  close() {
    this.modalRef.close();
  }
}
